import { Button, Modal, ModalBody, ModalContent, useDisclosure } from '@nextui-org/react'
import { IconPencil, IconPlus } from '@tabler/icons-react';
import React, { Fragment, useEffect, useState } from 'react'
import { AlertTriangle, Edit3, X } from 'lucide-react';
import SparkleButton from './SparkleButton';
import { useNavigate } from 'react-router-dom';
import { RouteConstant } from '../routes/RouteConstant';

const AccessRestrictionDialog = ({edit, btnName, content, loadInitial}) => {

    const { title = "", subtitle = "", message = "", bulletPoints = []  } = content

    const {isOpen, onOpen, onOpenChange} = useDisclosure();

    const navigate = useNavigate()

    useEffect(() => {
        if(loadInitial){
            handleOpen()
        }
    }, []);
    
    const handleOpen = () => {
        onOpen()
    };

    const handleCancel = () => {
        if(loadInitial){
            onOpenChange()
            navigate(RouteConstant.VESSEL)
        }else{
            onOpenChange()
        }
    };

    return(
        <Fragment>
            {
                !loadInitial &&
                <SparkleButton
                handleClick={handleOpen}
                Icon={edit ? IconPencil : IconPlus}
                btnName={btnName}
                />
            }
            <Modal
            isDismissable={false}
            backdrop="opaque"
            size="xl"
            scrollBehavior="inside"
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            hideCloseButton
            classNames={{
            backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
            base: "min-h-[300px] overflow-auto bg-transparent shadow-none",
            }}
            >
                <ModalContent>
                {(onClose) => (
                    <Fragment>
                        <ModalBody>
                            <div className="bg-white rounded-2xl overflow-hidden border border-red-100">
                                <div className="bg-gradient-to-r from-red-50 to-orange-50 px-6 py-4 border-b border-red-100">
                                    <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
                                        <AlertTriangle className="h-5 w-5 text-red-600" />
                                        </div>
                                        <div>
                                        <h3 className="font-semibold text-gray-900 text-sm">{title}</h3>
                                        <p className="text-xs text-gray-600">{subtitle}</p>
                                        </div>
                                    </div>
                                    <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={handleCancel}
                                    className="h-8 w-8 p-0 hover:bg-red-100 rounded-full"
                                    >
                                        <X className="h-4 w-4 text-gray-500" />
                                    </Button>
                                    </div>
                                </div>

                                <div className="px-6 py-5">
                                    <div className="mb-4">
                                    <p className="text-sm text-gray-700 leading-relaxed">
                                        {message}
                                    </p>
                                    {bulletPoints?.length > 0 && (
                                        <ul className="mt-3 space-y-1 text-xs text-gray-600">
                                        {bulletPoints.map((point, idx) => (
                                            <li key={idx} className="flex items-center">
                                            <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full mr-2" />
                                            {point}
                                            </li>
                                        ))}
                                        </ul>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </Fragment>
                )}
                </ModalContent>
            </Modal>
        </Fragment>
    )
}

export default AccessRestrictionDialog
